<div class="event-history-dialog">
    
    <div class="d-flex bd-highlight">
        <div class="p-0 w-100 bd-highlight"><h5>{{"HISTORY" | translate}}</h5></div>
        <div class="p-0 flex-shrink-1 bd-highlight close-button-holder"><span (click)="close()" class="close-button">&times;</span></div>
    </div>
    <div class="p-2 py-0 table-padding">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>{{"DATE" | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.date}} </td>
            </ng-container>

            <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef>{{"TIME_TEXT" | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.time}} </td>
            </ng-container>

            <ng-container matColumnDef="event">
                <th mat-header-cell *matHeaderCellDef>{{"EVENT" | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.eventName | translate}} </td>
            </ng-container>

            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>{{"USER" | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="down-close-button px-0">
        <button class="btn btn-primary" (click)="close()">{{"CLOSE" | translate}}</button>
        </div>
    </div>
</div>
